import { cs } from './languages/cs';
import { en } from './languages/en';
import { ru } from './languages/ru';

export const resources = { cs, en, ru };
